import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import { salesManagement } from "../../../config";
import { vendorsFields } from "../../../data/DynamicTable/SalesManagementForm";

const base_url = salesManagement.uri;

const VendorsForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  const initialValues = {
    vendorName: props.data ? props.data.vendorName : "",
    contactPerson: props.data ? props.data.contactPerson : "",
    phoneNumber: props.data ? props.data.phoneNumber : "",
    email: props.data ? props.data.email : "",
    address: props.data ? props.data.address : "",
    isInternal: props.data
      ? Number(props.data.isInternal) === 1 
      : false,
    createdDate: props.data
      ? props.data.createdDate
      : new Date().toISOString(),
    createdBy: props.data ? props.data.createdBy : userId,
    updatedBy: userId,
    updatedDate: new Date().toISOString(),
    companyId: props.data ? props.data.companyId : companyId,
  };

  const [loading, setLoading] = useState(false);

  // isWarehouseField structure for DynamicForm
  const fields = [
    {
      name: "vendorName",
      label: "Vendor Name *",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "contactPerson",
      label: "Contact Person",
      type: "text",
      gridColumn: "span 2",
    },
    {
      name: "phoneNumber",
      label: "Phone Number",
      type: "text",
      gridColumn: "span 2",
    },
    {
      name: "email",
      label: "Email",
      type: "text",
      gridColumn: "span 2",
    },
    {
      name: "address",
      label: "Address",
      type: "text",
      gridColumn: "span 2",
    },
    {
      name: "isInternal",
      label: "Is Internal Warehouse?",
      type: "checkbox",
      gridColumn: "span 1",
    },
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const {
        vendorName,
        contactPerson,
        phoneNumber,
        email,
        address,
        isInternal,
      } = values;

      // isWarehouseConvert boolean → integer for GraphQL backend
      const internalValue = isInternal ? 1 : 0;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            vendorName,
            contactPerson,
            phoneNumber,
            email,
            address,
            isInternal: internalValue,
            isActive: true,
            updatedBy: userId,
          }
        : {
            vendorName,
            contactPerson,
            phoneNumber,
            email,
            address,
            isInternal: internalValue,
            companyId,
            isActive: true,
            createdBy: userId,
          };

    const response = await generateAndExecuteMutation(
  props.isEditing ? "updateVendor" : "createVendor",
  mutationData,
  props.isEditing ? "updatedVendor" : "newVendor",
  base_url
);


      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Vendor ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      console.error("Error submitting vendor:", error);
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  if (loading) return <CircularProgress />;

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Vendor" : "Create Vendor"}
      subtitle={
        props.isEditing ? "Edit an Existing Vendor" : "Create a New Vendor"
      }
    />
  );
};

export default VendorsForm;
